import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import App from './App';

const oneSignalAppId = process.env.REACT_APP_ONESIGNAL_APP_ID;

const initOneSignal = async () => {
  if (!oneSignalAppId) {
    if (process.env.NODE_ENV === 'development') {
      // Не роняем приложение в dev, если push-уведомления не настроены.
      console.warn('OneSignal is disabled: REACT_APP_ONESIGNAL_APP_ID is missing.');
    }
    return;
  }

  try {
    const { default: OneSignal } = await import('react-onesignal');
    await OneSignal.init({
      appId: oneSignalAppId,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: false,
      },
      promptOptions: {
        slidedown: {
          prompts: [
            {
              type: 'push',
              autoPrompt: true,
              text: {
                actionMessage: 'Разрешите уведомления чтобы получать новости о потерянных животных',
                acceptButton: 'Разрешить',
                cancelButton: 'Нет',
              },
            },
          ],
        },
      },
    });
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('OneSignal init failed:', e);
    }
  }
};

initOneSignal();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
